/**
 * Attribute NotFound Throwable Error
 */
export class AttributeNotFound extends Error {
  constructor ({ attribute, model }, ...params) {
    super(...params)
    this.name = '[Model::AttributeNotFound]'
    this._attribute = attribute
    this._model = model
  }

  toString () {
    return `'${this._attribute}' doesn't exist on '${this._model}' model.`
  }
}

/**
 * Retrievable method not found throwable error
 *
 * @param {{ modelName, retrievableName }} params
 * @param {Object} errorParams
 */
export class RetrievableMethodNotFound extends Error {
  constructor ({ modelName, retrievableName }, ...params) {
    super(...params)
    this.name = '[Model::RetrievableMethodNotFound]'
    this._modelName = modelName
    this._retrievableName = retrievableName
  }

  toString () {
    return `'${this._modelName}' must implement '${this._retrievableName}' retrievable method (get${this._retrievableName[0].toUpperCase() + this._retrievableName.slice(1)}Attribute).`
  }
}

/**
 * Empty csv header throwable error
 *
 * @param {{ modelName }} params
 * @param {Object} errorParams
 */
export class MissingCsvHeaders extends Error {
  constructor ({ modelName }, ...params) {
    super(...params)
    this.name = '[Model::MissingCsvHeaders]'
    this._modelName = modelName
  }

  toString () {
    return `'${this._modelName}' must implement 'defaultCsvHeaders' static method or to receive columns argument by generateCsv method (columns my be privded as array with at least one item).`
  }
}
